export const HTTP_STATUS_CODES = {
  CONFLICT: 409,
  NOT_FOUND: 404,
  NOT_ACCEPTABLE: 406
};